import {observer} from "mobx-react";
import * as React from "react";
import {WelcomeHeader} from "components/signup/shared/WelcomeHeader";
import {UIState} from "data/UIState";
import {action, observable} from "mobx";
import UserDataSource from "data/UserDataSource";
import {PageEnums} from "components/nav/PageEnums";
import {EMPTY_LOCATION} from "../../data/entities/ILocation";
import {Alert} from "../../data/Alert";
import {UnderLogin} from "../login/UnderLogin";


interface Props {
}

/**
 * This page is used to collect a location
 * if locations are enable
 *
 */
@observer
export class LocationPage extends React.Component<Props> {
  @observable saving = false;
  @observable location = EMPTY_LOCATION;

  @action handleLocationChange = (e) => {
    if(e.target.value==='') {
      this.location = EMPTY_LOCATION;
    } else {
      const possibleLocation = UIState.settings.LOCATIONS.find(l=>l._id===e.target.value);
      this.location = possibleLocation ? possibleLocation : EMPTY_LOCATION;
    }
  }

  @action saveLocationSelection = () => {
    if(!this.location) {
      Alert.alert('You must select a location in order to continue.',);
    } else if(!this.saving) {
      this.saving = true;
      UserDataSource.saveUserProfile(UIState.user, {_location: this.location._id, avatarURL: UIState.user.avatarURL})
        .then(() => {
          this.saving = false;
          UIState.currentPage = PageEnums.dashboard;
        })
        .catch(() => {
          Alert.alert('Continue failed. This could be due to an unstable Internet connection. Please try again.',);
          this.saving = false;
        });
    }
  }

  render() {
    const bg = {backgroundImage:`url('${UIState.settings.BG}')` };
    return (
      <div className="signup">
        <div className="signup-content" style={bg}>
          <div className="col" style={{borderTop:'8px solid #243294'}}>

            <WelcomeHeader title={""} description={"Please provide the following required information in order to continue to the dashboard. "} />

            <div className={`form-element`}>
              <label>{UIState.settings.LOCATION_LABEL}</label>
              <select name="location" id="location" onChange={this.handleLocationChange} value={this.location._id}>
                <option value={''}>Select {UIState.settings.LOCATION_LABEL}...</option>
                {UIState.settings.LOCATIONS.map(location=><option key={location._id} value={location._id}>{location.name}</option>)}
              </select>
            </div>
            <div className={'form-element tight'}>
              <a className="cta-button noselect" onClick={this.saveLocationSelection}>Continue</a>
            </div>
          </div>
        </div>
        <UnderLogin />
      </div>
    );
  }

}
